import React from 'react';
import Reflux from 'reflux';
import Actions from './actions';
import Store from './store';
import DateSelector from './date_selector';
import { fromJS } from 'immutable';
import { Row, Col, Navbar } from 'react-bootstrap';
import DocumentTitle from 'react-document-title';
import ChartBars from '../charts/bars';
import LineChart from '../charts/line';
import MapChart from '../charts/map';
import EmailSubscription from '../form/email_subscription';
import _ from 'lodash';

const EXPLANATIONS = {
  'gun-control':        `Answers to the question &ldquo;Do you support or
                      oppose stricter gun control laws in the USA?&rdquo;`,
  'tax-policy':         `Answers to the question &ldquo;Do you support for
                      raising income tax for income over $250,000?&rdquo;`,
  'presidential-candidates':         `Answers to the question &ldquo;Who do you support
                      for President of the USA?&rdquo;`,
  'immigration-policy': `Answers to the question &ldquo;Do you support increase
                      in flow of immigrants to USA?&rdquo;`
};

const DOCUMENT_TITLES = {
  'gun-control': 'DECISION 2016 - THE KEY ELECTION ISSUES - Gun Control | Pollfish',
  'tax-policy': 'DECISION 2016 - THE KEY ELECTION ISSUES - Tax Policy | Pollfish',
  'presidential-candidates': 'DECISION 2016 - THE KEY ELECTION ISSUES - Presidential Candidates | Pollfish',
  'immigration-policy': 'DECISION 2016 - THE KEY ELECTION ISSUES - Immigration Policy | Pollfish'
}

const GunControl = React.createClass({

  mixins: [ Reflux.listenTo(Store, 'onDataChange')],

  componentDidMount() {
    this.fetchData(this.props.params);
  },

  componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps.params)
  },

  fetchData(params) {
    Actions.fetchData(params);
    Actions.getLineChartData();
  },

  onDataChange(data) {
    this.setState(data)
  },

  getInitialState() {
    return {
      filteredMonths: {},
      lineChartData: fromJS([]),
      currentResults: fromJS({}),
      categories: fromJS([])
    };
  },

  _renderBarData() {
    const { currentResults } = this.state;
    const { dataset } = this.props.params;

    return (
      <div>
        <DocumentTitle title={DOCUMENT_TITLES[dataset]}></DocumentTitle>
        <div className="chart-bars">
          <ChartBars data={currentResults.toJS()} />
          <div className="chart-bars__note" dangerouslySetInnerHTML={{__html: EXPLANATIONS[dataset]}} />
        </div>
      </div>
    );
  },

  render() {
    return (
      <Row className="row-full-height">
        <Col xs={12} lg={8} className="col-flex-lg left-area">
          <Navbar className="pf-navbar">
            <Navbar.Header>
              <h5>Select Dates</h5>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <DateSelector location={this.props.location} params={this.props.params} />
            </Navbar.Collapse>
          </Navbar>
          {this._renderBarData()}
          <MapChart data={this.state.mapResults} />
        </Col>
        <Col xs={12} lg={4} className="col-flex-lg right-area">
          <div className="right-area__info">
            <h5>Info</h5>
            <p>How do people feel about Presidential Candidates, Gun control,
              Taxation and Immigration in your state? Check out the infographic
              to find out!</p>

            <p>We will continue to monitor these key wedge issues until the
              November Election.</p>
          </div>
          <LineChart
            categories={this.state.categories}
            series={this.state.lineChartData}
          />
          <div className="right-area__email-subscription">
            <h5>Keep on track</h5>
            <p>Stay up-to-date with updated results</p>
            <EmailSubscription />
          </div>
        </Col>
      </Row>
    );
  }
});

export default GunControl;



/** WEBPACK FOOTER **
 ** ./src/components/data_visualisation/index.js
 **/